import { setup } from "web/entrypoints/common/setup";
import "./css-feeds";
import components from "./react-feeds";

setup(components);
